<template>
  <div class="info">
    <p v-if="!notLabel" class="info__label">{{ labelText }}:</p>

    <VTooltip
      :popupText="!link ? text : link"
      :showTip="showTooltip"
    >
      <div class="text-content" v-if="!link && !otherShowText.length && !useClickEvent" v-html="currentText" />

      <p v-if="!link && otherShowText.length && !useClickEvent">
        {{ otherShowText }}
      </p>

      <div
        v-if="useClickEvent"
        class="link text-content"
        @click="$emit('clickLink')"
        v-html="currentText" />
      <AppLink
        v-else-if="link"
        :length="length"
        :link="link"
        :text="currentText"
      />
    </VTooltip>
  </div>
</template>

<script>
import AppLink from '../simple/button/AppLink'
import VTooltip from './VTooltip'
import stringMaxLengthFilter from '@/filters/stringMaxLength.filter'
import { sanitizeHtml } from '@/utils/string'

export default {
  name: 'AppInfoTextBlock',
  components: { VTooltip, AppLink },
  props: {
    labelText: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number, null],
      default: ''
    },
    otherShowText: {
      type: [String, Number, null],
      default: ''
    },
    link: {
      type: [String, Number],
      default: ''
    },
    length: {
      type: Number,
      default: 30
    },
    hasTooltip: {
      type: Boolean,
      default: true
    },
    notLabel: {
      type: Boolean,
      default: false
    },
    useClickEvent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentText () {
      const text = sanitizeHtml(this.text?.toString())
      if (!text) return '-'

      return this.hasTooltip ? stringMaxLengthFilter(text, this.length) : text
    },

    showTooltip () {
      const text = sanitizeHtml(this.text?.toString())
      return this.hasTooltip && (text?.length > this.length) && !this.link
    }
  }
}
</script>
